<template>
  <div>
    <b-container fluid>
      <b-row class="p-0">
        <b-col md="3" class="p-0">
          <div class="dashside">
            <div class="dashtext p-3">
              <b-link :to="{ name: 'landing' }" class="dbl">
                <b-icon-arrow-left font-scale="1.2" class="mr-3"></b-icon-arrow-left>
              </b-link>
              CEO Dashboard
              <b-button v-b-toggle.sidebar-dash class="m-1 sbb" variant="info">
                <b-icon-list font-scale="2"></b-icon-list>
              </b-button>
              <b-sidebar
                id="sidebar-dash"
                title="Dashboard"
                backdrop-variant="dark"
                backdrop
                shadow
              >
                <div class="pr-0 pb-3 pb-5 mt-1 pl-3">
                  <div class="ldiv">
                    <b-link
                      class="dashlink"
                      active-class="mactive"
                      :to="{ name: 'ceohome' }"
                    >
                      <b-icon-calendar class="mr-3" font-scale="1.5"></b-icon-calendar>
                      CEO Dashboard
                    </b-link>
                    <b-link
                      class="dashlink"
                      active-class="active"
                      :to="{ name: 'allcounts' }"
                    >
                      <b-icon-card-checklist
                        class="mr-3"
                        font-scale="1.5"
                      ></b-icon-card-checklist>
                      All Counts
                    </b-link>
                    <b-link class="dashlink" active-class="active" :to="{ name: 'hr' }">
                      <p class="freetext">
                        <b-icon-alarm class="mr-3" font-scale="1.5"></b-icon-alarm>
                        Add an Admin
                      </p>
                    </b-link>
                    <b-link
                      class="dashlink"
                      active-class="active"
                      :to="{ name: 'upgrader' }"
                    >
                      <p class="freetext">
                        <b-icon-book class="mr-3" font-scale="1.5"></b-icon-book>
                        Upgrade A User
                      </p>
                    </b-link>
                    <b-link
                      class="dashlink"
                      active-class="active"
                      :to="{ name: 'emailer' }"
                    >
                      <p class="freetext">
                        <b-icon-bar-chart-steps
                          class="mr-3"
                          font-scale="1.5"
                        ></b-icon-bar-chart-steps>
                        Send Emails
                      </p>
                    </b-link>
                  </div>
                  <div class="adiv">
                    <a
                      href="https://quicktestng.com/pricing"
                      v-if="plan == 'Free'  &&
                    (curD.getFullYear() == 2020 && curD.getMonth() == 10 && curD.getDate() &gt; 22)"
                      class="premups p-2 text-center"
                      >Upgrade to Premium</a
                    >
                    <a class="premup p-2 text-center" @click="logout"
                      >Log Out
                      <b-icon-box-arrow-in-right
                        font-scale="1"
                      ></b-icon-box-arrow-in-right
                    ></a>
                  </div>
                </div>
              </b-sidebar>
            </div>
            <div class="dashbody pr-0 pb-3 pb-5 mt-1 pl-3">
              <b-link class="dashlink" active-class="mactive" :to="{ name: 'ceohome' }">
                <b-icon-calendar class="mr-3" font-scale="1.5"></b-icon-calendar>
                CEO Dashboard
              </b-link>
              <b-link class="dashlink" active-class="active" :to="{ name: 'allcounts' }">
                <b-icon-card-checklist
                  class="mr-3"
                  font-scale="1.5"
                ></b-icon-card-checklist>
                All Counts
              </b-link>
              <b-link class="dashlink" active-class="active" :to="{ name: 'hr' }">
                <p class="freetext">
                  <b-icon-alarm class="mr-3" font-scale="1.5"></b-icon-alarm>
                  Add an Admin
                </p>
              </b-link>
              <b-link class="dashlink" active-class="active" :to="{ name: 'upgrader' }">
                <p class="freetext">
                  <b-icon-book class="mr-3" font-scale="1.5"></b-icon-book>
                  Upgrade A User
                </p>
              </b-link>
              <b-link class="dashlink" active-class="active" :to="{ name: 'emailer' }">
                <p class="freetext">
                  <b-icon-bar-chart-steps
                    class="mr-3"
                    font-scale="1.5"
                  ></b-icon-bar-chart-steps>
                  Send Emails
                </p>
              </b-link>
            </div>
          </div>
        </b-col>

        <b-col md="9" class="test">
          <b-row>
            <b-col></b-col>
            <b-col>
              <div class="date p-3 mb-2 text-right">
                {{ new Date() | moment("DD MMM YYYY, dddd") }}
              </div>
            </b-col>
          </b-row>
          <router-view></router-view>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
//import NProgress from 'nprogress'
import store from "@/store";
import { mapState, mapActions } from "vuex";

export default {
  created() {
    if (!this.loggedin) {
      this.$router.push({
        name: "landin",
      });
    }
  },
  data() {
    return {
      curD: new Date(),
    };
  },
  mounted() {
    if (!this.loggedin) {
      this.$router.push({
        name: "landing",
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch("admin/getCounts");
    store.dispatch("admin/getUsers");
    next();
  },
  methods: {
    ...mapActions(["logOut"]),
    logout() {
      if (confirm("Are you sure you want to log out? Saved Changes may be lost")) {
        this.logOut();

        this.$router.push({
          name: "login",
        });
      }
    },
  },
  computed: {
    ...mapState({
      details: (state) => state.loginmaster.details,
      loggedin: (state) => state.loginmaster.loggedIn,
      start_config: (state) => state.exam.start_config,
      plan: (state) => state.loginmaster.details.plan,
      trial: (state) => state.loginmaster.trial,
      premium: (state) => state.loginmaster.details.premium_details,
      started: (state) => state.exam.started,
      allinsti: (state) => state.exam.allinstitutions,
    }),
  },
};
</script>

<style scoped>
.dashside {
  background-color: white;
  margin-top: -18px;
  height: 100%;
}

.dashtext {
  font-size: 25px;
  font-family: "Times New Roman", Times, serif;
  color: gray;
}

.dashbody {
}

.dashlink {
  display: flex;
  font-size: 20px;
  margin-top: 2rem;
  text-decoration: none;
  color: black;
}

.freetext {
  width: 85%;
  margin-bottom: -11px;
}

.prelock {
  width: 15%;
}

.active {
  border-right: 7px solid #00377b;
  color: #00377b;
}

.mactive {
  color: gray;
  border-right: 5px solid red;
}

.dbl {
  color: black;
}

.prelock {
  display: inline-block;
  margin-left: 100px;
}
.adiv {
  margin-top: 20px;
  height: 20vh;
}
.ldiv {
  height: 60vh;
}

.predisa {
  color: gray;
}

.premup {
  position: relative;
  display: block;
  bottom: -35px;
  text-decoration: none;
  width: 250px;
  color: white;
  font-weight: bold;
  font-size: 1.5rem;
  background-color: #00377b;
  border-radius: 15px 15px;
  margin-left: 20px;
  cursor: pointer;
}

.premup:hover {
  color: #00377b;
  border: 1px solid #00377b;
  background-color: white;
}

.premups {
  display: block;
  margin-top: 10px;
  position: relative;
  bottom: -25px;
  width: 250px;
  text-decoration: none;
  color: white;
  font-weight: bold;
  font-size: 1.5rem;
  background-color: #00377b;
  border-radius: 15px 15px;
  margin-left: 20px;
}

.premups:hover {
  color: #00377b;
  border: 1px solid #00377b;
  background-color: white;
}

@media screen and (min-width: 768px) {
  .sbb {
    display: none;
  }
}

@media (max-width: 768px) {
  .dashbody {
    display: none;
  }
}
</style>
